import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_EditGroupPermission = _resolveComponent("EditGroupPermission")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, {
        pageTitle: "edit_group_permission",
        items: [
        { label: 'group_permission', to: '/group-permission' },
        { label: 'edit_group_permission' },
      ],
        "show-home": false
      }),
      _createVNode(_component_EditGroupPermission),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}